// removed by extract-text-webpack-plugin
module.exports = {"OtpModalDialog":"OtpModalDialog","CancelMultiOrderModal":"CancelMultiOrderModal","Title":"Title","OrderTable":"OrderTable"};


//////////////////
// WEBPACK FOOTER
// ./src/components/areas/Account/OrderBook/CancelMultiOrder/styles.scss
// module id = 2018
// module chunks = 10